export enum ActionType {
    EVAL_FORM__RELOAD = 'EVAL_FORM__RELOAD',
    EVAL_FORM__RELOAD_RESULT = 'EVAL_FORM__RELOAD_RESULT',
    EVAL_FORM__SAVE = 'EVAL_FORM__SAVE',
    EVAL_FORM__SAVE_RESULT = 'EVAL_FORM__SAVE_RESULT',
    EVAL_FORM__SHOW_PUBLISH_CONFIRM_DIALOG = 'EVAL_FORM__SHOW_PUBLISH_CONFIRM_DIALOG',
    EVAL_FORM__HIDE_PUBLISH_CONFIRM_DIALOG = 'EVAL_FORM__HIDE_PUBLISH_CONFIRM_DIALOG',
    EVAL_FORM__RESET = 'EVAL_FORM__RESET',
}
